import { HeaderSearchDesktop } from './HeaderSearchDesktop';
import { HeaderSearchMobile } from './HeaderSearchMobile';

export const HeaderSearchSlot = {
  desktop: HeaderSearchDesktop,
  mobile: HeaderSearchMobile,
};

export * from './SearchBarRightItemsMobile';
